import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const whatsappApi = createApi({
  reducerPath: "whatsappApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    credentials: "include",
  }),
  tagTypes: ["WhatsApp", "WhatsAppCatalog", "WhatsAppOrders"],
  endpoints: (builder) => ({
    connectWhatsApp: builder.mutation({
      query: (payload) => ({
        url: "/whatsapp/connect",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["WhatsApp"],
    }),

    getWhatsAppStatus: builder.query({
      query: () => ({
        url: "/whatsapp/status",
      }),
      providesTags: ["WhatsApp"],
    }),

    syncLabelledStockToWhatsAppCatalog: builder.mutation({
      query: ({ branchId } = {}) => ({
        url: "/whatsapp/sync-labelled-stock",
        method: "POST",
        body: branchId ? { branchId } : {},
      }),
      invalidatesTags: ["WhatsAppCatalog"],
    }),

    getWhatsAppCatalogItems: builder.query({
      query: ({ branchId } = {}) => ({
        url: "/whatsapp/catalog-items",
        params: branchId ? { branchId } : {},
      }),
      providesTags: ["WhatsAppCatalog"],
    }),

    getWhatsAppOrders: builder.query({
      query: ({ branchId } = {}) => ({
        url: "/whatsapp/orders",
        params: branchId ? { branchId } : {},
      }),
      providesTags: ["WhatsAppOrders"],
    }),

    sendWhatsAppTestMessage: builder.mutation({
      query: (payload) => ({
        url: "/whatsapp/send-test-message",
        method: "POST",
        body: payload,
      }),
    }),

    sendWhatsAppCatalogItem: builder.mutation({
      query: (payload) => ({
        url: "/whatsapp/send-catalog-item",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["WhatsAppCatalog"],
    }),

updateWhatsAppCatalogPublishStatus: builder.mutation({
  query: ({ id, isWhatsappPublished }) => ({
    url: `/whatsapp/catalog/${id}/publish`,
    method: "PATCH",
    body: { isWhatsappPublished },
  }),
  invalidatesTags: ["WhatsAppCatalog"],
}),


updateWhatsAppOrderStatus: builder.mutation({
  query: ({ id, status }) => ({
    url: `/whatsapp/orders/${id}/status`,
    method: "PATCH",
    body: { status },
  }),
  invalidatesTags: ["WhatsAppOrders"],
}),

  }),
});

export const {
  useConnectWhatsAppMutation,
  useGetWhatsAppStatusQuery,
  useSyncLabelledStockToWhatsAppCatalogMutation,
  useGetWhatsAppCatalogItemsQuery,
  useGetWhatsAppOrdersQuery,
  useSendWhatsAppTestMessageMutation,
  useSendWhatsAppCatalogItemMutation,
  useUpdateWhatsAppCatalogPublishStatusMutation,
  useUpdateWhatsAppOrderStatusMutation
} = whatsappApi;

export default whatsappApi;